// Page-side rules of the dynamic login wall (plans/dynamic-login-wall.md,
// Phase 3). Milla's config/loginWall.js holds the list rules; these are the
// checks the SDK makes itself before and after asking for the post's decision.
// The eager core carries this file; the bundle's own rules are in
// wallConfig.js.
module.exports = {
  // Rule F walls only articles at least this old (Milla checks it again).
  MIN_AGE_DAYS: 7,
  // Article ads wait this long for the wall's verdict, so a walled view never
  // requests the units it hides; a wall not decided by then never shows.
  // Matches the ads' profile deadline (adsAuthTimeoutMs).
  ADS_WAIT_MS: 2500,
  // ?milla_login_wall=preview renders the wall on any article for QA and
  // Google's Rich Results Test; it reports nothing.
  PREVIEW_PARAM: 'milla_login_wall',
  PREVIEW_VALUE: 'preview'
};
